import Navbar from '../ui/Navbar'

const Header = () => {
    return (
        <header className={`py-5 ssm:px-10 px-5 mx-auto max-w-screen-2xl flex justify-between items-center`}>
            <Navbar />
        </header>
    )
}

export default Header
